import {BlockStatus} from '../../pages/network-assets/context/types/aggregation-state'
import {NetworkType} from '../../pages/network-assets/context/types/network-type'
import {type LocationIdType} from '../../store/state/locations/state'
import {
    type DetailExpandedType,
    type FilterExpandedType,
    NetworkAssetsSortType,
    TimestampFilterType,
} from '../../store/state/network-assets-filter/state'
import {type GuidType} from '../generic-type-defintions'

export interface NetworkAssetsFilterCriteria {
    orderBy: {column: NetworkAssetsSortType; isAscending: boolean}
    networks: NetworkType[] | undefined
    behaviours: GuidType[] | undefined
    properties: string | undefined
    pagination: {pageSize: 10; pageOffset: 0}
    vlan: string | undefined
    macAddress: string | undefined
    fromRelativeLastSeen: TimestampFilterType | undefined
    unknownBlockStatuses: Record<BlockStatus, boolean>
    monitoredOnly: boolean
    blockStatuses?: BlockStatus[]
}

export const DEFAULT_NETWORK_ASSETS_FILTER_CRITERIA: NetworkAssetsFilterCriteria = {
    orderBy: {
        column: NetworkAssetsSortType.TIMESTAMP,
        isAscending: false,
    },
    networks: undefined,
    behaviours: undefined,
    properties: undefined,
    pagination: {pageSize: 10, pageOffset: 0},
    vlan: undefined,
    macAddress: undefined,
    fromRelativeLastSeen: undefined,
    unknownBlockStatuses: {
        undecided: false,
        trusted: false,
        blocked: false,
    },
    monitoredOnly: false,
}

export interface NetworkAssetsFilter {
    orderBy: {column: NetworkAssetsSortType; isAscending: boolean}
    networks: NetworkType[] | undefined
    behaviours: GuidType[] | undefined
    properties: string | undefined
    pagination: {pageSize: 10; pageOffset: 0}
    vlan: string | undefined
    macAddress: string | undefined
    fromRelativeLastSeen: TimestampFilterType | undefined
    filterExpanded: FilterExpandedType
    detailExpanded: DetailExpandedType
    selectedVessels: LocationIdType[] | undefined
    searchVesselTagTerm: string[]
    searchVesselNameTerm: string
    unknownBlockStatuses: Record<BlockStatus, boolean>
    monitoredOnly: boolean
    blockStatuses?: BlockStatus[]
}

export const DEFAULT_NETWORK_ASSETS_FILTER: NetworkAssetsFilter = {
    orderBy: {
        column: NetworkAssetsSortType.TIMESTAMP,
        isAscending: false,
    },
    networks: undefined,
    behaviours: undefined,
    properties: undefined,
    pagination: {pageSize: 10, pageOffset: 0},
    vlan: undefined,
    macAddress: undefined,
    fromRelativeLastSeen: undefined,
    filterExpanded: {
        assetExpanded: true,
        vesselExpanded: true,
        networkExpanded: true,
        behavioursExpanded: true,
        propertiesExpanded: true,
    },
    detailExpanded: {
        detailsExpanded: true,
        insightsExpanded: true,
        actionsExpanded: true,
    },
    selectedVessels: undefined,
    searchVesselTagTerm: [],
    searchVesselNameTerm: '',
    unknownBlockStatuses: {
        trusted: false,
        blocked: false,
        undecided: false,
    },
    monitoredOnly: false,
}

export interface NetworkAssetsFilterForUserPref {
    selectedFilterName: string
    locations: LocationIdType[] | undefined
    searchVesselTagTerm: string[]
    searchVesselNameTerm: string
    detailExpanded: DetailExpandedType
}
